import React from 'react';
import EQReturnStatus from './EQReturnStatus';
import ShipmentStatus from './ShipmentStatus';
import EquipmentToBeReturn from './EquipmentsToReturn';
import { isNullOrUndefined } from './CommonFunctions';

export default class EquipmentDetails extends React.Component {
    constructor(props) {
        super(props)
    }

    getERStorelocatorUrl() {
		return "https://www.verizon.com/stores/search-results/?fios=equipment";
    }
    
    render() {
        if(!isNullOrUndefined(this.props.DynamicData)  && Object.keys(this.props.DynamicData).length > 0 && Object.keys(this.props.DynamicData.orderDetails).length > 0 ) {
            return (
                <div className="tiny-padding-vert-tiny medium-padding-vert-small padding-top-medium">
                    <EQReturnStatus Title={this.props.SignInStaticData.titledesc[0].title} DueDate={this.props.DynamicData.equipDetails[0].ReturnDueDate}></EQReturnStatus>
                    <ShipmentStatus EQData={this.props.SignInStaticData} ERDynamic={this.props.DynamicData} Open={this.props.DialogOpen} DateFormat={this.props.ChangeDateFormat}></ShipmentStatus>
                    <EquipmentToBeReturn EQData={this.props.SignInStaticData} ERDynamicData={this.props.DynamicData}></EquipmentToBeReturn>
                    <button className="button medium-p-auto print_label" onClick={this.props.ClickHandler} data-track={this.props.SignInStaticData.ctalist[0].label1}>{this.props.SignInStaticData.ctalist[0].label1}</button>
                </div>
            )
        } else {
            return (
                <div className="padding-right-tiny">
                    <h5 className="margin-top-zero red_font title">Equipment return status</h5>
                    <div className="tiny-padding-vert-tiny medium-padding-vert-small padding-top-medium er_message_wrap">
                        <h6 className="margin-top-zero er_message">
                        We are unable to locate your order details. Please check if information was entered correctly. 
                        If you need store locations, 
                        <a href={this.getERStorelocatorUrl()} data-track="Store locator link"> Click here </a>. 
                        For additional help, click on the CHAT button.
                        </h6>
                    </div>
                </div>
                
            )
        }

    }
    
}


// WEBPACK FOOTER //
// ./src/components/modules/EquipmentDetails.js